import {useLocale} from 'next-intl'

import {Locale} from '@/utils/constants'

export const getLanguage = (language: string) =>
  Object.values(Locale).includes(language as Locale) ? (language as Locale) : Locale.en

export const useLanguage = () => {
  const locale = useLocale()
  return getLanguage(locale)
}
